@if (isActive()) {
    <div class="absolute w-full left-0 text-center top-0 border-1 border-red-600 z-1 backdrop-blur-lg rounded p-2 overflow-x-hidden whitespace-nowrap text-ellipsis">
      {{message()}}
    </div>
}
